import * as Constants from './constants';
import { fullName, abbreviated, tooltip } from './messages';
import OptionCodes from '../../constants/other-shipping-options-constants';
import { IncludeReturnLabelContainer } from '../../orders/other-shipping-options/components/include-return-label-container';
import { B13aCanada } from '../../orders/other-shipping-options/components/inputs/b13a-canada';
import { BillToAccountOption } from '../../orders/other-shipping-options/components/inputs/bill-to-account/bill-to-account';
import { CollectOnDeliveryOption } from '../../orders/other-shipping-options/components/inputs/cod';
import { ConsequentialLossOption } from '../../orders/other-shipping-options/components/inputs/consequential-loss';
import {
  DangerousGoods,
  DangerousGoodsLegacy,
  DangerousGoodsPurolator,
} from '../../orders/other-shipping-options/components/inputs/dangerous-goods';
import { DangerousGoodsDHLEcom } from '../../orders/other-shipping-options/components/inputs/dangerous-goods-dhl-ecom';
import { DefaultOption } from '../../orders/other-shipping-options/components/inputs/default-option';
import { DeliveredDutyPaidOption } from '../../orders/other-shipping-options/components/inputs/delivered-duty-paid-option';
import { DryIceInput } from '../../orders/other-shipping-options/components/inputs/dry-ice';
import { EmailNotificationOption } from '../../orders/other-shipping-options/components/inputs/email-notification';
import { FedExBookingConfirmation } from '../../orders/other-shipping-options/components/inputs/fedEx-booking-confirmation/fedEx-booking-confirmation';
import { FedExShipperLoadAndCount } from '../../orders/other-shipping-options/components/inputs/fedEx-shipper-load-and-count/fedEx-shipper-load-and-count';
import { FreightClassCode } from '../../orders/other-shipping-options/components/inputs/freight-class-code';
import { SafeplaceInput } from '../../orders/other-shipping-options/components/inputs/safeplace';
import { RegulatedContentTypeDropdown } from './../../orders/other-shipping-options/components/inputs/regulated-content-type-dropdown';
import { ServiceLevelDropdown } from '../../orders/other-shipping-options/components/inputs/service-level-dropdown';
import { SMSNotificationOption } from '../../orders/other-shipping-options/components/inputs/sms-notification';
import { WindsorFrameworkMovementIndicatorDropdown } from '../../orders/other-shipping-options/components/inputs/windsor-framework-movement-indicator-dropdown';
import { AncillaryEndorsement } from './../../orders/other-shipping-options/components/inputs/ancillary-endorsement/';

export const OtherShippingOptions = [
  {
    id: OptionCodes.additionalHandling,
    fullName: fullName.additionalHandling,
    abbreviatedName: abbreviated.additionalHandling,
    category: Constants.shipmentOptions,
    component: DefaultOption,
    optionName: Constants.additionalHandling,
  },
  {
    id: OptionCodes.alcohol,
    fullName: fullName.alcohol,
    abbreviatedName: abbreviated.alcohol,
    category: Constants.shipmentOptions,
    component: DefaultOption,
    optionName: Constants.alcohol,
  },
  {
    id: OptionCodes.b13ACanada,
    fullName: fullName.b13ACanada,
    abbreviatedName: abbreviated.b13ACanada,
    category: Constants.shipmentOptions,
    component: B13aCanada,
    optionName: Constants.b13ACanada,
  },
  {
    id: OptionCodes.consequentialLoss,
    fullName: fullName.consequentialLoss,
    abbreviatedName: abbreviated.consequentialLoss,
    category: Constants.shipmentOptions,
    component: ConsequentialLossOption,
    optionName: Constants.consequentialLoss,
  },
  {
    id: OptionCodes.dangerousGoods,
    fullName: fullName.dangerousGoods,
    abbreviatedName: abbreviated.dangerousGoods,
    category: Constants.shipmentOptions,
    component: DangerousGoods,
    optionName: Constants.dangerousGoods,
  },
  {
    id: OptionCodes.dangerousGoodsLegacy,
    fullName: fullName.dangerousGoodsLegacy,
    abbreviatedName: abbreviated.dangerousGoodsLegacy,
    category: Constants.shipmentOptions,
    component: DangerousGoodsLegacy,
    optionName: Constants.dangerousGoodsLegacy,
  },
  {
    id: OptionCodes.dangerousGoodsSimple,
    fullName: fullName.dangerousGoodsSimple,
    abbreviatedName: abbreviated.dangerousGoodsSimple,
    category: Constants.shipmentOptions,
    component: DefaultOption,
    optionName: Constants.dangerousGoodsSimple,
  },
  {
    id: OptionCodes.dangerousGoodsDhlEcommerce,
    fullName: fullName.dangerousGoodsDhlEcommerceFullName,
    abbreviatedName: abbreviated.dangerousGoodsDhlEcommerceAbbreviated,
    category: Constants.shipmentOptions,
    component: DangerousGoodsDHLEcom,
    optionName: Constants.dangerousGoodsDhlEcommerce,
  },
  {
    id: OptionCodes.dangerousGoodsPurolator,
    fullName: fullName.dangerousGoodsPurolator,
    abbreviatedName: abbreviated.dangerousGoodsPurolator,
    category: Constants.shipmentOptions,
    component: DangerousGoodsPurolator,
    optionName: Constants.dangerousGoodsPurolator,
  },
  {
    id: OptionCodes.freightClass,
    fullName: fullName.freightClass,
    abbreviatedName: abbreviated.freightClass,
    category: Constants.shipmentOptions,
    component: FreightClassCode,
    optionName: Constants.freightClass,
  },
  {
    id: OptionCodes.nonMachinable,
    fullName: fullName.nonMachineable,
    abbreviatedName: abbreviated.nonMachineable,
    category: Constants.shipmentOptions,
    component: DefaultOption,
    optionName: Constants.nonMachinable,
  },
  {
    id: Constants.billToAccountCode,
    fullName: fullName.billToAccount,
    abbreviatedName: abbreviated.billToAccount,
    category: Constants.shipmentOptions,
    component: BillToAccountOption,
    optionName: Constants.billToAccount,
  },
  {
    id: OptionCodes.fedExShipperLoadAndCount,
    fullName: fullName.fedExShipperLoadAndCount,
    abbreviatedName: abbreviated.fedExShipperLoadAndCount,
    category: Constants.shipmentOptions,
    component: FedExShipperLoadAndCount,
    optionName: Constants.fedExShipperLoadAndCount,
  },
  {
    id: OptionCodes.fedExBookingConfirmation,
    fullName: fullName.fedExBookingConfirmation,
    abbreviatedName: abbreviated.fedExBookingConfirmation,
    category: Constants.shipmentOptions,
    component: FedExBookingConfirmation,
    optionName: Constants.fedExBookingConfirmation,
  },
  {
    id: OptionCodes.billToSender,
    fullName: fullName.billToSender,
    abbreviatedName: abbreviated.billToSender,
    category: Constants.labelOptions,
    component: DeliveredDutyPaidOption,
    optionName: Constants.deliveredDutyPaid,
  },
  {
    id: OptionCodes.dontPrepayPostage,
    fullName: fullName.dontPrepayPostage,
    abbreviatedName: abbreviated.dontPrepayPostage,
    category: Constants.labelOptions,
    component: DefaultOption,
    optionName: Constants.dontPrepayPostage,
  },
  {
    id: OptionCodes.dryIce,
    fullName: fullName.dryIce,
    abbreviatedName: abbreviated.dryIce,
    category: Constants.labelOptions,
    component: DryIceInput,
    optionName: Constants.dryIce,
  },
  {
    id: OptionCodes.includeReturnLabel,
    fullName: fullName.includeReturnLabel,
    abbreviatedName: abbreviated.includeReturnLabel,
    category: Constants.labelOptions,
    component: IncludeReturnLabelContainer,
    optionName: Constants.includeReturnLabel,
  },
  {
    id: OptionCodes.printPostage,
    fullName: fullName.printPostage,
    abbreviatedName: abbreviated.printPostage,
    category: Constants.labelOptions,
    component: DefaultOption,
    optionName: Constants.printPostage,
  },
  {
    id: OptionCodes.specialHandling,
    fullName: fullName.specialHandling,
    abbreviatedName: abbreviated.specialHandling,
    category: Constants.labelOptions,
    component: DefaultOption,
    optionName: Constants.specialHandling,
  },
  {
    id: OptionCodes.collectOnDelivery,
    fullName: fullName.collectOnDelivery,
    abbreviatedName: abbreviated.collectOnDelivery,
    category: Constants.deliveryOptions,
    component: CollectOnDeliveryOption,
    optionName: Constants.collectOnDelivery,
  },
  {
    // this is probably dead
    id: OptionCodes.collectOnDeliverySimple,
    fullName: fullName.collectOnDeliverySimple,
    abbreviatedName: abbreviated.collectOnDeliverySimple,
    category: Constants.deliveryOptions,
    component: DefaultOption,
    optionName: Constants.collectOnDeliverySimple,
  },
  {
    id: OptionCodes.holdForPickup,
    fullName: fullName.holdForPickup,
    abbreviatedName: abbreviated.holdForPickup,
    category: Constants.deliveryOptions,
    component: DefaultOption,
    optionName: Constants.holdForPickup,
  },
  {
    id: OptionCodes.localCollect,
    fullName: fullName.localCollect,
    abbreviatedName: abbreviated.localCollect,
    category: Constants.deliveryOptions,
    component: DefaultOption,
    optionName: Constants.localCollect,
  },
  {
    id: OptionCodes.safeplace,
    fullName: fullName.safeplace,
    abbreviatedName: abbreviated.safeplace,
    category: Constants.deliveryOptions,
    component: SafeplaceInput,
    optionName: Constants.safeplace,
  },
  {
    id: OptionCodes.saturdayDelivery,
    fullName: fullName.saturdayDelivery,
    abbreviatedName: abbreviated.saturdayDelivery,
    category: Constants.deliveryOptions,
    component: DefaultOption,
    optionName: Constants.saturdayDelivery,
  },
  {
    id: OptionCodes.saturdayGuarantee,
    fullName: fullName.saturdayGuarantee,
    abbreviatedName: abbreviated.saturdayGuarantee,
    category: Constants.deliveryOptions,
    component: DefaultOption,
    optionName: Constants.saturdayGuarantee,
  },
  {
    id: OptionCodes.shipperRelease,
    fullName: fullName.shipperRelease,
    abbreviatedName: abbreviated.shipperRelease,
    category: Constants.deliveryOptions,
    component: DefaultOption,
    optionName: Constants.shipperRelease,
  },
  {
    id: OptionCodes.thirdPartyConsignee,
    fullName: fullName.thirdPartyConsignee,
    abbreviatedName: abbreviated.thirdPartyConsignee,
    category: Constants.deliveryOptions,
    component: DefaultOption,
    optionName: Constants.thirdPartyConsignee,
  },
  {
    id: OptionCodes.emailNotification,
    fullName: fullName.emailNotification,
    abbreviatedName: abbreviated.emailNotification,
    category: Constants.notificationOptions,
    component: EmailNotificationOption,
    optionName: Constants.emailNotification,
  },
  {
    id: OptionCodes.smsNotification,
    fullName: fullName.smsNotification,
    abbreviatedName: abbreviated.smsNotification,
    category: Constants.notificationOptions,
    component: SMSNotificationOption,
    optionName: Constants.smsNotification,
  },
  {
    id: OptionCodes.doNotNotifyMarketplace,
    fullName: fullName.doNotNotifyMarketplace,
    abbreviatedName: abbreviated.doNotNotifyMarketplace,
    category: Constants.marketplaceOptions,
    component: DefaultOption,
    optionName: Constants.dontNotifyMarketplace,
  },
  {
    id: OptionCodes.ancillaryEndorsement,
    fullName: fullName.ancillaryEndorsementFullName,
    abbreviatedName: abbreviated.ancillaryEndorsementAbbreviated,
    category: Constants.shipmentOptions,
    component: AncillaryEndorsement,
    optionName: Constants.ancillaryEndorsement,
  },
  {
    id: OptionCodes.blockAmazonLogistics,
    fullName: fullName.blockAmazonLogistics,
    abbreviatedName: abbreviated.blockAmazonLogistics,
    category: Constants.externalFulfillmentOptions,
    component: DefaultOption,
    optionName: Constants.blockAmazonLogistics,
    tooltip: tooltip.blockAmazonLogistics,
  },
  {
    id: OptionCodes.useBlankBox,
    fullName: fullName.useBlankBox,
    abbreviatedName: abbreviated.useBlankBox,
    category: Constants.externalFulfillmentOptions,
    component: DefaultOption,
    optionName: Constants.useBlankBox,
  },
  {
    id: OptionCodes.goGreenPlus,
    fullName: fullName.goGreenPlus,
    abbreviatedName: abbreviated.goGreenPlus,
    category: Constants.deliveryOptions,
    component: DefaultOption,
    optionName: Constants.goGreenPlus,
  },
  {
    id: OptionCodes.regulatedContentType,
    fullName: fullName.regulatedContentType,
    abbreviatedName: abbreviated.regulatedContentType,
    category: Constants.shipmentOptions,
    component: RegulatedContentTypeDropdown,
    optionName: Constants.regulatedContentType,
  },
  {
    id: OptionCodes.movementIndicator,
    fullName: fullName.movementIndicator,
    abbreviatedName: abbreviated.movementIndicator,
    category: Constants.windsorFrameworkOptions,
    component: WindsorFrameworkMovementIndicatorDropdown,
    optionName: Constants.movementIndicator,
  },
  {
    id: OptionCodes.serviceLevel,
    fullName: fullName.serviceLevel,
    abbreviatedName: abbreviated.serviceLevel,
    category: Constants.serviceLevelOptions,
    component: ServiceLevelDropdown,
    optionName: Constants.serviceLevel,
  },
  {
    id: OptionCodes.notAtRisk,
    fullName: fullName.notAtRisk,
    abbreviatedName: abbreviated.notAtRisk,
    category: Constants.windsorFrameworkOptions,
    component: DefaultOption,
    optionName: Constants.notAtRisk,
  },
  {
    id: OptionCodes.exportLicenceRequired,
    fullName: fullName.exportLicenceRequired,
    abbreviatedName: abbreviated.exportLicenceRequired,
    category: Constants.windsorFrameworkOptions,
    component: DefaultOption,
    optionName: Constants.exportLicenceRequired,
  },
  {
    id: OptionCodes.fragile,
    fullName: fullName.fragile,
    abbreviatedName: abbreviated.fragile,
    category: Constants.shipmentOptions,
    component: DefaultOption,
    optionName: Constants.fragile,
  },
  {
    id: OptionCodes.deliveryAsAddressed,
    fullName: fullName.deliveryAsAddressed,
    abbreviatedName: abbreviated.deliveryAsAddressed,
    category: Constants.deliveryOptions,
    component: DefaultOption,
    optionName: Constants.deliveryAsAddressed,
  },
  {
    id: OptionCodes.returnAfterFirstAttempt,
    fullName: fullName.returnAfterFirstAttempt,
    abbreviatedName: abbreviated.returnAfterFirstAttempt,
    category: Constants.deliveryOptions,
    component: DefaultOption,
    optionName: Constants.returnAfterFirstAttempt,
  },
];
